(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentDisplayPersonController', Controller);

    Controller.$inject = ['$scope', 'env', 'esbEmployeeService'];

    function Controller($scope, env, esbEmployeeService) {

        $scope.displayPerson = {};

        var employeeToFound = 'Didier Rano';
        if (_.isUndefined(env.isDev) || env.isDev === false) {
            employeeToFound = 'David Ouellet';
        }

        esbEmployeeService.searchEmployees(employeeToFound)
            .then(function (employees) {
                $scope.displayPerson.Person = employees[0];
            });

        $scope.selectPerson = function (person) {
            $scope.displayPerson.Person = person;
        }

        $scope.getLayout = function () {
            if (_.isUndefined($scope.displayPerson.photoColumnLayout) && 
                _.isUndefined($scope.displayPerson.infosColumnLayout)) {
                return undefined;
            }

            var layout = "";
            if ($scope.displayPerson.photoColumnLayout) {
                layout += "photoColumn: '" + $scope.displayPerson.photoColumnLayout + "'";
            }
            if ($scope.displayPerson.infosColumnLayout) {
                if (layout.length > 0) layout += ", ";
                layout += "infosColumn: '" + $scope.displayPerson.infosColumnLayout + "'";
            }

            return "{ " + layout + " }";
        }
    }
})();